module.exports = __webpack_public_path__ + "img/office4.df24e395.jpg";